import React from 'react';

const GridviewIcon = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M6.25 7.26379V4.99115C6.25 4.28533 5.93 4 5.135 4H3.115C2.32 4 2 4.28533 2 4.99115V7.25878C2 7.96961 2.32 8.24994 3.115 8.24994H5.135C5.93 8.25494 6.25 7.96961 6.25 7.26379Z"
      fill="currentColor"
    />
    <path
      opacity="0.4"
      d="M11.5 7.26379V4.99115C11.5 4.28533 11.18 4 10.385 4H8.365C7.57 4 7.25 4.28533 7.25 4.99115V7.25878C7.25 7.96961 7.57 8.24994 8.365 8.24994H10.385C11.18 8.25494 11.5 7.96961 11.5 7.26379Z"
      fill="currentColor"
    />
    <path
      d="M16.75 7.26379V4.99115C16.75 4.28533 16.43 4 15.635 4H13.615C12.82 4 12.5 4.28533 12.5 4.99115V7.25878C12.5 7.96961 12.82 8.24994 13.615 8.24994H15.635C16.43 8.25494 16.75 7.96961 16.75 7.26379Z"
      fill="currentColor"
    />
    <path
      opacity="0.4"
      d="M22 7.26379V4.99115C22 4.28533 21.68 4 20.885 4H18.865C18.07 4 17.75 4.28533 17.75 4.99115V7.25878C17.75 7.96961 18.07 8.24994 18.865 8.24994H20.885C21.68 8.25494 22 7.96961 22 7.26379Z"
      fill="currentColor"
    />
    <path
      opacity="0.4"
      d="M6.25 13.5138V11.2412C6.25 10.5353 5.93 10.25 5.135 10.25H3.115C2.32 10.25 2 10.5353 2 11.2412V13.5088C2 14.2196 2.32 14.4999 3.115 14.4999H5.135C5.93 14.5049 6.25 14.2196 6.25 13.5138Z"
      fill="currentColor"
    />
    <path
      d="M11.5 13.5138V11.2412C11.5 10.5353 11.18 10.25 10.385 10.25H8.365C7.57 10.25 7.25 10.5353 7.25 11.2412V13.5088C7.25 14.2196 7.57 14.4999 8.365 14.4999H10.385C11.18 14.5049 11.5 14.2196 11.5 13.5138Z"
      fill="currentColor"
    />
    <path
      opacity="0.4"
      d="M16.75 13.5138V11.2412C16.75 10.5353 16.43 10.25 15.635 10.25H13.615C12.82 10.25 12.5 10.5353 12.5 11.2412V13.5088C12.5 14.2196 12.82 14.4999 13.615 14.4999H15.635C16.43 14.5049 16.75 14.2196 16.75 13.5138Z"
      fill="currentColor"
    />
    <path
      d="M22 13.5138V11.2412C22 10.5353 21.68 10.25 20.885 10.25H18.865C18.07 10.25 17.75 10.5353 17.75 11.2412V13.5088C17.75 14.2196 18.07 14.4999 18.865 14.4999H20.885C21.68 14.5049 22 14.2196 22 13.5138Z"
      fill="currentColor"
    />
    <path
      d="M6.25 19.7638V17.4912C6.25 16.7853 5.93 16.5 5.135 16.5H3.115C2.32 16.5 2 16.7853 2 17.4912V19.7588C2 20.4696 2.32 20.7499 3.115 20.7499H5.135C5.93 20.7549 6.25 20.4696 6.25 19.7638Z"
      fill="currentColor"
    />
    <path
      opacity="0.4"
      d="M11.5 19.7638V17.4912C11.5 16.7853 11.18 16.5 10.385 16.5H8.365C7.57 16.5 7.25 16.7853 7.25 17.4912V19.7588C7.25 20.4696 7.57 20.7499 8.365 20.7499H10.385C11.18 20.7549 11.5 20.4696 11.5 19.7638Z"
      fill="currentColor"
    />
    <path
      d="M16.75 19.7638V17.4912C16.75 16.7853 16.43 16.5 15.635 16.5H13.615C12.82 16.5 12.5 16.7853 12.5 17.4912V19.7588C12.5 20.4696 12.82 20.7499 13.615 20.7499H15.635C16.43 20.7549 16.75 20.4696 16.75 19.7638Z"
      fill="currentColor"
    />
    <path
      opacity="0.4"
      d="M22 19.7638V17.4912C22 16.7853 21.68 16.5 20.885 16.5H18.865C18.07 16.5 17.75 16.7853 17.75 17.4912V19.7588C17.75 20.4696 18.07 20.7499 18.865 20.7499H20.885C21.68 20.7549 22 20.4696 22 19.7638Z"
      fill="currentColor"
    />
  </svg>
);
export default GridviewIcon;
